import { readNativeFile } from "./files";
import { isNativeApp } from "./platform";

/** Photos, PDFs or text another app handed over via "Teilen". */
export interface SharedItem {
  readonly title: string;
  readonly texts: readonly string[];
  readonly files: readonly File[];
}

export type SharedItemHandler = (item: SharedItem) => void;

/**
 * Native only: deliver content shared into the app ("Teilen mit …").
 * Returns an async-safe unsubscribe; no-op in browsers.
 */
export async function onShareReceived(
  handler: SharedItemHandler,
): Promise<() => void> {
  if (!isNativeApp()) return () => {};
  try {
    const { CapacitorShareTarget } = await import(
      "@capgo/capacitor-share-target"
    );
    const handle = await CapacitorShareTarget.addListener(
      "shareReceived",
      (event) => {
        void Promise.all(
          event.files.map((f) => readNativeFile(f.uri, f.name, f.mimeType)),
        ).then((files) => {
          handler({
            title: event.title,
            texts: event.texts,
            files: files.filter((f): f is File => f !== null),
          });
        });
      },
    );
    return () => {
      void handle.remove();
    };
  } catch {
    return () => {};
  }
}
